export const CONSTS = {
  ADD_HEADER: $localize`New Location Profile`,
  EDIT_HEADER: $localize`Edit Location Profile`,
};

export const TABS = {
  LOCATION: $localize`Location`,
  GROUP: $localize`Group`,
  CONFIGURATION: $localize`Configuration`,
};

export const BUTTON_TEXT = {
  CANCEL: $localize`Cancel`,
  RESET: $localize`Reset`,
  NEXT: $localize`Next`,
  SAVE: $localize`Save`,
};

export const CANCEL_MODAL = {
  HEADER: $localize`Cancel`,
  BODY: $localize`Are you sure you want to cancel? Your changes will not be saved.`,
  CONFIRM_BUTTON: $localize`Yes, Cancel`,
  REJECT_BUTTON: $localize`No`,
};
